import api from './api';
import { Category, CategoryFormData } from '@/types/taxonomy';

export const taxonomyApi = {
    // Kategorileri listele
    getCategories: async (): Promise<Category[]> => {
        const response = await api.get('/admin/taxonomy');
        return response.data;
    },

    // Kategori oluştur
    createCategory: async (data: CategoryFormData): Promise<Category> => {
        const response = await api.post('/admin/taxonomy', data);
        return response.data;
    },

    // Kategori güncelle
    updateCategory: async (id: string, data: Partial<CategoryFormData>): Promise<Category> => {
        const response = await api.put(`/admin/taxonomy/${id}`, data);
        return response.data;
    },

    // Kategori sil
    deleteCategory: async (id: string): Promise<void> => {
        await api.delete(`/admin/taxonomy/${id}`);
    },

    // Tek kategori getir
    getCategoryById: async (id: string): Promise<Category> => {
        const response = await api.get(`/admin/taxonomy/${id}`);
        return response.data;
    },
};
